import style from "./style.module.scss";

export default function Survey(props) {
  const { value, options, disabled, valueChange } = props;
  return (
    <div className={style.select} data-disabled={disabled}>
      {options?.map(__option => (
        <div
          className={style.option}
          onClick={() => {
            valueChange(__option.value);
          }}
          data-selected={value === __option.value}
        >
          <div className={style.option_info}>
            <span>{__option.label}</span>
            <span>{parseFloat(__option.percent.toFixed(2))}%</span>
          </div>
          <div className={style.percent_bar} style={{ width: `${__option.percent}%` }}></div>
        </div>
      ))}
    </div>
  );
}
